import { AxiosResponse } from "axios";
import { Action } from "redux-saga";
import { call, CallEffect, PutEffect } from "redux-saga/effects";
import api from "../../../settings/api";
import environment from "../../../settings/environment";
import { clearString } from "@/utils/functions";

export interface Fetch {
  plate: string;
  pin: string;
  callback: (success: boolean, errorMessage?: string) => void;
}

export interface ValidatePinAvulsoAction {
  type: string;
  payload: Fetch;
}

export default function* validatePinAvulso({
  payload,
}: ValidatePinAvulsoAction): Generator<
  CallEffect<unknown> | PutEffect<Action>,
  void,
  AxiosResponse
> {
  try {
    const data = {
      document: clearString(payload.plate).toUpperCase(),
      pinCode: payload.pin,
    };
    const response = yield call(api.post, `/v1/customers/pins/validate`, data, {
      headers: {
        Empresa: environment.api.enterprise,
      },
    });

    const isStatusOk =
      response?.data?.status?.codigoRetorno === 0 || response?.status === 200;
    const isPinValid =
      !response?.data?.data?.code || response?.data?.data?.code !== "4";

    if (isStatusOk && isPinValid) {
      yield call(payload.callback, true);
    } else {
      yield call(payload.callback, false, "error");
    }
  } catch (error) {
    yield call(
      payload.callback,
      false,
      // @ts-expect-error
      error?.response?.data?.status?.codigoRetorno === -1002
        ? "plate"
        : "timeout",
    );
  }
}
